import { AtsAnalyticsDirectivesPushEventOnClickModule } from '@alliance/ats/analytics/directives/push-event-on-click'
import { AtsAnalyticsDirectivesPushEventOnViewModule } from '@alliance/ats/analytics/directives/push-event-on-view'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OnboardingComponent } from './onboarding/onboarding.component'
import { WhereToStartComponent } from './categories/where-to-start/where-to-start.component'
import { CandidatesInProjectComponent } from './categories/candidates-in-project/candidates-in-project.component'
import { CategoryNavigationComponent } from './categories/category-navigation/category-navigation.component'
import { CategoriesPanelComponent } from './categories/categories-panel/categories-panel.component'
import { CategoryItemComponent } from './categories/category-item/category-item.component'
import { SharedCarouselGalleryModule } from '@alliance/shared/carousel-gallery'
import { SharedIconsModule } from '@alliance/shared/icons'
import { SharedTranslationModule } from '@alliance/shared/translation'
import { SantaTooltipModule } from '@alliance/santa/tooltip'
import { SantaButtonModule } from '@alliance/santa/button'
import { RouterModule } from '@angular/router'
import { ShowOnboardingDirectiveModule } from '../directives/show-onboarding-directive'
import { ActionsWithCandidatesComponent } from './categories/actions-with-candidates/actions-with-candidates.component'
import { FunnelComponent } from './categories/funnel/funnel.component'
import { StatisticsAndAnalyticsComponent } from './categories/statistics-and-analytics/statistics-and-analytics.component'
import { UserRightsComponent } from './categories/user-rights/user-rights.component'
import { SlideTemplateComponent } from './categories/slides/slide-template/slide-template.component'

@NgModule({
  declarations: [
    OnboardingComponent,
    WhereToStartComponent,
    CandidatesInProjectComponent,
    CategoryNavigationComponent,
    CategoriesPanelComponent,
    CategoryItemComponent,
    ActionsWithCandidatesComponent,
    FunnelComponent,
    StatisticsAndAnalyticsComponent,
    UserRightsComponent,
    SlideTemplateComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SantaButtonModule,
    SantaTooltipModule,
    SharedTranslationModule,
    SharedIconsModule,
    SharedCarouselGalleryModule,
    ShowOnboardingDirectiveModule,
    AtsAnalyticsDirectivesPushEventOnViewModule,
    AtsAnalyticsDirectivesPushEventOnClickModule
  ]
})
export class OnboardingWidgetModule {}
